<div id="list-item-1" class="Container" data-aos="zoom-in">


    <img src="../assets/photos/main_page.jpeg" class="image">

  
    <img src="../assets/logos/maharat foundation logo white.png" class="MaharatLogo">

    <img src="../assets/logos/NDU.png" class="NDULogo">
    

    <div class="SocialMedia">
        <a href="https://www.facebook.com/MaharatFoundation/">
            <img src="../assets/logos/Facebook.png" class="SocialMediaLogo">
        </a>
        <a href="https://www.youtube.com/user/MaharatFoundation">
            <img src="../assets/logos/youtube.png" class="SocialMediaLogo">
        </a>
        <a href="https://www.instagram.com/maharatfoundation/">
            <img src="../assets/logos/instagram.png" class="SocialMediaLogo">
        </a>
        <a href="https://twitter.com/Maharat_Lebanon?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor">
            <img src="../assets/logos/twitter.png" class="SocialMediaLogo">
        </a>
    </div>

    <div class="centered">الأطفال ذوو الاحتياجات الخاصة في لبنان: بين مطرقة الجائحة وسندان الاهمال</div>

</div>